"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cachePromise = cachePromise;
function cachePromise(fn) {
  var cache = new Map();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var key = JSON.stringify(args);
    if (!cache.has(key)) {
      var promise = fn(...args);
      cache.set(key, promise);
    }
    return cache.get(key);
  };
}